import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Checkbox, FormControlLabel } from '@mui/material';
import { useController } from 'react-hook-form';
import { useStore } from '../../../components/store/Store';
import SettingsInputContainer from '../../../components/SettingsInputContainer';
import Container from '../../../components/Container';
import { Site } from '../../../declarations/models/Site';

export const WebpageSystemSettings: FC = () => {
  const { t } = useTranslation('components');
  const { state } = useStore();
  const isSuperAdmin = state.currentUser?.user?.is_super_admin;

  const {
    field: { value: script, onChange: onChangeScript },
  } = useController<Site, `content.settings.scripts`>({
    name: `content.settings.scripts`,
  });

  const {
    field: { value: footerScript, onChange: onChangeFooterScript },
  } = useController<Site, `content.settings.footerScripts`>({
    name: `content.settings.footerScripts`,
  });

  const {
    field: { value: cssClass, onChange: onChangeCssClass },
  } = useController<Site, `content.cssClass`>({
    name: `content.cssClass`,
  });

  const {
    field: { value: siteIsNotAphysicalLocation, onChange: onChangeSiteIsNotAphysicalLocation },
  } = useController<Site, `content.siteIsNotAphysicalLocation`>({
    name: `content.siteIsNotAphysicalLocation`,
  });

  const {
    field: { value: dmChannel, onChange: onChangeDmChannel },
  } = useController<Site, `content.settings.dmChannel`>({
    name: `content.settings.dmChannel`,
  });

  const {
    field: { value: footerV2, onChange: onChangeFooterV2 },
  } = useController<Site, `content.settings.footer_v2`>({
    name: `content.settings.footer_v2`,
  });

  return (
    <>
      {isSuperAdmin && (
        <div className='superadmin' style={{ backgroundColor: '#fbe6ff', padding: '1em', width: '100%' }}>
          <SettingsInputContainer title={t(`Settings.WebpageSettings.WebpageSystemSettings.scripts`)}>
            <Container fullWidth spaceBetween gap={2}>
              <Container column left fullWidth>
                <TextField
                  fullWidth
                  multiline
                  minRows={10}
                  maxRows={50}
                  variant='outlined'
                  value={script}
                  onChange={(e) => onChangeScript(e.target.value)}
                />
              </Container>
            </Container>
          </SettingsInputContainer>
          <SettingsInputContainer title={t(`Settings.WebpageSettings.WebpageSystemSettings.footerScripts`)}>
            <Container fullWidth spaceBetween gap={2}>
              <Container column left fullWidth>
                <TextField
                  fullWidth
                  multiline
                  minRows={10}
                  maxRows={50}
                  variant='outlined'
                  value={footerScript}
                  onChange={(e) => onChangeFooterScript(e.target.value)}
                />
              </Container>
            </Container>
          </SettingsInputContainer>

          <SettingsInputContainer title={t(`Settings.WebpageSettings.WebpageSystemSettings.diverse`)}>
            <Container fullWidth spaceBetween gap={2}>
              <Container column left fullWidth>
                <TextField
                  fullWidth
                  label={t(`Settings.WebpageSettings.WebpageSystemSettings.cssClass`)}
                  variant='outlined'
                  value={cssClass}
                  onChange={(e) => onChangeCssClass(e.target.value)}
                />
              </Container>
            </Container>

            <Container fullWidth spaceBetween gap={2} column>
              <Container column left fullWidth>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={siteIsNotAphysicalLocation}
                      onChange={(e) => onChangeSiteIsNotAphysicalLocation(e.target.checked)}
                    />
                  }
                  label={t(`Settings.WebpageSettings.WebpageSystemSettings.siteIsNotAphysicalLocation`)}
                />
              </Container>
              <Container column left fullWidth>
                <FormControlLabel
                  control={<Checkbox checked={dmChannel} onChange={(e) => onChangeDmChannel(e.target.checked)} />}
                  label={t(`Settings.WebpageSettings.WebpageSystemSettings.dmChannel`)}
                />
              </Container>
              <Container column left fullWidth>
                <FormControlLabel
                  control={<Checkbox checked={footerV2} onChange={(e) => onChangeFooterV2(e.target.checked)} />}
                  label='V2 footer'
                />
              </Container>
            </Container>
          </SettingsInputContainer>
        </div>
      )}
    </>
  );
};

export default WebpageSystemSettings;
